<script>
import { BButton, BModal } from 'bootstrap-vue';
import BuilderCard from './BuilderCard.vue';
import CheckoutList from './CheckoutList.vue';

export default {
  components: {
    BModal,
    BButton,
    BuilderCard,
    CheckoutList,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },

    page: {
      type: Number,
      required: false,
      default: null,
    },

    form: {
      type: Object,
      required: false,
      default: null,
    },

    hasCheckout: {
      required: false,
    },
  },

  data: () => ({
    step: 0,
    query: '',
    formName: '',
    formValue: '',
    editing: false,
    saving: false,
    questions: null,
    formType: 'default',
    showQuestions: false,
    options: [
      //
    ],
  }),

  created () {
    this.$http.get('/form')
      .then(({ data }) => {
        this.options = data;
      });

    if (this.form) {
      this.step = 2;
      this.editing = true;
      this.formType = 'checkout';
    }
  },

  computed: {
    cards () {
      return [
        {
          type: 'default',
          title: 'Formulário Padrão',
          description: 'Criar Formulário de captação de leads padrão.',
          icon: '<svg class="bdk-h-6 bdk-w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">   <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /> </svg>',
        },
        {
          type: 'checkout',
          title: 'Formulário de Checkout',
          description: 'Criar Formulário para recebimento de pagamentos em landing pages.',
          icon: '<svg class="bdk-h-6 bdk-w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /> </svg>',
        },
        {
          type: 'lists',
          title: 'Formulários Existentes',
          description: 'Selecionar um Formulário existente.',
          icon: '<svg class="bdk-h-6 bdk-w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"> <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" /> </svg>',
        },
        {
          type: 'checkout-lists',
          title: 'Formulários de Checkout Existentes',
          description: 'Selecionar um Formulário de checkout existente.',
          icon: '<svg class="bdk-h-6 bdk-w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"> <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" /> </svg>',
        },
      ];
    },
  },

  methods: {
    handleModalQuestion ({ questions }) {
      if (questions.length === 0) {
        return;
      }

      this.questions = questions;

      this.showQuestions = true;
    },

    next () {
      if (this.step === 1 && this.formType === 'default') {
        this.handleCreate();

        return;
      }

      if (this.step === 0 && this.formType === 'checkout') {
        this.step = 2;

        return;
      }

      this.step += 1;
    },

    prev () {
      if (this.formName) {
        this.formName = '';
      }

      if (this.formType === 'checkout' && this.step === 2) {
        this.step = 0;

        return;
      }

      this.step -= 1;
    },

    handleCreate (form = null) {
      this.saving = true;

      if (form) {
        this.$emit('create', form);

        return;
      }

      this.$http.post('/form', { name: this.formName })
        .then(({ data }) => {
          this.$emit('create', data.form);
        });
    },

    handleClose () {
      Bus.$emit('saveBeeForm');
    },

    handleSave (form) {
      this.saving = true;

      if (['checkout', 'checkout-lists'].includes(this.formType)) {
        Bus.$emit('saveBeeForm', toBeeForm(form, [], this.page));

        this.$emit('close', form);

        return;
      }

      this.$http.get(`/form/${form.id}/question`)
        .then(({ data }) => {
          const questions = _.sortBy(data, 'order');

          Bus.$emit('saveBeeForm', toBeeForm(form, questions, this.page));

          this.$emit('close', form);
        });
    },

    handleSearch: _.debounce(function () {
      const {
        query,
      } = this;

      this.$http.get(`/form/search?q=${query}`)
        .then(({ data }) => {
          this.options = data;
        });
    }, 250),

    editCheckout (form) {
      this.$emit('update:form', form);

      this.step = 2;
      this.formType = 'checkout';
    },

    closeEdit () {
      this.$emit('update:form', null);

      this.prev();
    },
  },
};
</script>

<template>
  <div
    class="form-builder-dialog bdk-bg-white"
  >
    <button
      class="form-builder-dialog__close"
      @click.prevent="handleClose"
    >
      <IconClose color="#b2a8c1" />
    </button>

    <div
      class="form-builder-dialog__body bdk-bg-white"
    >
      <template
        v-if="step === 0"
      >
        <h2
          class="form-builder-dialog__body-title text-center"
        >
          Selecione o formulário
        </h2>

        <p
          class="form-builder-dialog__body-text text-center"
        >
          Você pode criar um formulário comum, um formulário de checkout ou selecionar um formulário existente
        </p>

        <div
          key="create-forms"
          class="form-builder-dialog__body-create"
        >
          <div
            class="bdk-w-full bdk-flex bdk-flex-col"
          >
            <template
              v-for="card in cards"
            >
              <BuilderCard
                v-bind="card"
                :key="card.type"
                @selected="formType = $event"
                :active="formType === card.type"
                v-if="card.type !== 'checkout' || hasCheckout"
              />
            </template>
          </div>
        </div>
      </template>

      <template
        v-if="step === 1"
      >
        <h2
          class="form-builder-dialog__body-title text-center"
        >
          {{ formType === 'lists' ? 'Selecione um formulário' : 'Criação de formulário' }}
        </h2>

        <p
          class="form-builder-dialog__body-text text-center"
        >
          {{ formType.includes('lists') ? 'Pesquise abaixo e selecione o formulário que você deseja utilizar na página.' : 'Defina um nome do formulário' }}
        </p>

        <div
          key="create-forms"
          class="form-builder-dialog__body-create"
        >
          <div
            key="search-forms"
            v-if="formType === 'lists'"
            class="form-builder-dialog__wrapper"
          >
            <input
              label="name"
              v-model="query"
              id="search-forms"
              @input="handleSearch"
              class="form-builder-dialog__search-input"
              :placeholder="__('Digite para pesquisar um formulário')"
            >

            <div
              class="form-builder-dialog__body-forms"
            >
              <div
                :key="form.name + index"
                v-for="(form, index) of options"
                @click.prevent="handleSave(form)"
                class="form-builder-dialog__form"
              >
                <div
                  class="form-builder-dialog__form-content"
                >
                  <span
                    class="form-builder-dialog__form-name"
                    v-text="form.name"
                  />

                  <span
                    v-text="form.description"
                    class="form-builder-dialog__form-description"
                  />
                </div>

                <div
                  @click.stop
                  class="form-builder-dialog__form-questions"
                >
                  <span
                    class="form-builder-dialog__form-question"
                    @click.prevent="handleModalQuestion(form)"
                    :class="{ 'is-disabled': form.questions.length === 0 }"
                  >
                    Visualizar Campos
                  </span>
                </div>

                <button
                  class="form-builder-dialog__form-button"
                  @click.prevent.stop="handleCreate(form)"
                >
                  <IconEdit color="#3B334A" />
                </button>
              </div>

              <BModal
                size="sm"
                hide-header="hide-header"
                hide-footer="hide-footer"
                v-model="showQuestions"
                id="modal-form-questions"
                ref="modal-form-questions"
                modal-class="modal-no-header-no-footer"
              >
                <div
                  class="form-builder-dialog__modal"
                >
                  <button
                    class="form-builder-dialog__modal-close"
                    @click.prevent="showQuestions = false"
                  >
                    <IconClose />
                  </button>

                  <div
                    class="form-builder-dialog__modal-header"
                  >
                    <span
                      class="form-builder-dialog__modal-header-title"
                    >
                      Campos do Formulário
                    </span>
                  </div>

                  <div
                    :key="question"
                    v-for="({ question }) of questions"
                    class="form-builder-dialog__modal-item"
                  >
                    <span
                      v-text="question"
                      class="form-builder-dialog__modal-item-question"
                    />
                  </div>
                </div>
              </BModal>
            </div>
          </div>

          <CheckoutList
            @edit="editCheckout"
            @selected="handleSave"
            v-else-if="formType === 'checkout-lists'"
          />

          <label
            v-else
            class="form-builder-dialog__label"
          >
            Nome do formulário

            <input
              v-model="formName"
              class="form-builder-dialog__input"
              placeholder="Digite aqui"
            >
          </label>
        </div>
      </template>

      <template
        v-if="step === 2"
      >
        <div
          key="create-forms-checkout"
          class="form-builder-dialog__body-create"
        >
          <FormBuilderCheckout
            @close="prev"
            :name="formName"
            @back="handleSave"
            :editing="editing"
            :current-form="form"
            @closeEdit="closeEdit"
          />
        </div>
      </template>
    </div>

    <div
      class="form-builder-dialog__footer bdk-bg-white"
      v-if="step < 2"
    >
      <BButton
        type="submit"
        variant="secundary"
        :disabled="step === 0"
        @click.prevent="prev"
        class="form-builder-dialog__button"
      >
        <span>
          {{ __('Voltar') }}
        </span>
      </BButton>

      <BButton
        type="submit"
        variant="primary"
        @click.prevent="next"
        class="form-builder-dialog__button"
        :disabled="saving || step === 1 && (formType === 'lists' || ! formName)"
      >
        <span>
          {{ __('Continuar') }}
        </span>
      </BButton>
    </div>

    <div
      class="form-builder-dialog__bg"
    />
  </div>
</template>

<style lang="scss">
  @import '../../../sass/variables';

  .form-builder-dialog {
    width: 90%;
    bottom: 42px;
    display: flex;
    padding: 20px;
    max-width: 820px;
    border-radius: 5px;
    position: relative;
    flex-flow: column nowrap;
    background-color: $white-gray;
    box-shadow: 0 5px 30px $gray-dark;

    &__wrapper {
      display: flex;
      align-items: center;
      flex-flow: column nowrap;
    }

    &__header {
      height: 51px;
      color: $white;
      display: flex;
      font-weight: 400;
      padding: 13px 30px;
      font-size: .6875rem;
      align-items: center;
      box-sizing: border-box;
      letter-spacing: -.17px;
      text-transform: uppercase;
      background-color: $purple;
      justify-content: space-between;

      &-close {
        font-size: 1rem;
        font-weight: 600;
      }
    }

    &__close {
      top: 10px;
      right: 15px;
      border: none;
      position: absolute;
      background-color: transparent;
    }

    &__search {
      &-input {
        width: 90%;
        height: 52px;
        border: none;
        font-size: 13px;
        color: #3b334a;
        font-weight: 400;
        line-height: 16px;
        border-radius: 5px;
        box-sizing: border-box;
        background-color: white;
        padding: .375rem 26px .375rem 1.2rem;
        font-family: $font-family-sans-serif;
      }
    }

    &__body {
      flex-grow: 1;
      display: flex;
      overflow: hidden;
      color: $gray-dark;
      padding: 19px 60px;
      flex-flow: column nowrap;
      background-color: $white-gray;
      font-family: $font-family-sans-serif;

      &-text {
        font-size: 13px;
        font-weight: 400;
        line-height: 25px;
        letter-spacing: -0.2px;
        -webkit-text-stroke: thin;
      }

      &-forms {
        width: 100%;
        flex-grow: 1;
        display: flex;
        overflow: auto;
        padding: 0px 32px;
        box-sizing: border-box;
        flex-flow: column nowrap;
      }

      &-create {
        display: flex;
        margin-top: 9px;
        align-items: center;
        flex-flow: column nowrap;
      }
    }

    &__form {
      height: 60px;
      display: flex;
      flex-shrink: 0;
      font-size: 14px;
      cursor: pointer;
      font-weight: 500;
      margin-top: 12px;
      color: $gray-dark;
      padding: 0px 20px;
      border-radius: 5px;
      position: relative;
      align-items: center;
      background-color: $white;
      justify-content: space-between;
      box-shadow: 0 0 0 1px #e0e0e0, 0 2px 4px 0 rgba($black, .07), 0 1px 1.5px 0 rgba($black, .05) !important;

      &-content {
        flex-grow: 1;
        display: flex;
        flex-flow: column nowrap;
      }

      &-name,
      &-question {
        font-size: 14px;
        margin: 0px 8px;
        font-weight: 400;
        color: $gray-dark;
        font-family: $font-family-sans-serif;
      }

      &-question {
        &.is-disabled {
          color: $gray-soft;
          cursor: not-allowed;
        }

        &:hover:not(.is-disabled) {
          font-weight: bold;
        }
      }

      &-description {
        margin: 0px 8px;
        font-size: 12px;
        font-weight: 400;
        color: $gray-light;
        font-family: $font-family-sans-serif;
      }

      &-button {
        border: none;
        background-color: transparent;
      }

      &:hover {
        background: rgba(222,242,250,0.85);
        border: solid 1px #3AAEE0 !important;
      }
    }

    &__modal {
      box-sizing: border-box;

      & > :nth-child(2n + 3) {
        background-color: $gray-white;
      }

      &-close {
        top: 12px;
        right: 16px;
        padding: 0px;
        border: none;
        cursor: pointer;
        position: absolute;

        * {
          stroke: $gray-dark;
        }
      }

      &-header {
        padding: 8px;
        display: flex;
        margin-top: -14px;
        border-radius: 5px;
        justify-content: center;

        &-title {
          font-size: 14px;
          font-weight: bold;
          color: $gray-dark;
          font-family: $font-family-sans-serif;
        }
      }

      &-item {
        display: flex;
        padding: 8px 16px;
        justify-content: center;

        &-question {
          font-size: 14px;
          font-weight: 400;
          color: $gray-dark;
          font-family: $font-family-sans-serif;
        }
      }
    }

    &__footer {
      display: flex;
      padding: 19px 80px;
      justify-content: center;
      background-color: $white-gray;

      &-action {
        cursor: pointer;
        font-size: 13px;
        font-weight: 300;
        line-height: 25px;
        box-sizing: border-box;
        letter-spacing: -0.2px;
        -webkit-text-stroke: thin;

        &--underline {
          margin: 0px 2px;
          text-decoration: underline;
        }
      }
    }

    &__label {
      width: 100%;
      display: flex;
      font-size: 13px;
      flex-flow: column nowrap;

      &--checkbox {
        margin-top: 4px;
        align-items: center;
        flex-flow: row nowrap;
      }
    }

    &__input {
      height: 52px;
      line-height: 1.5;
      color: #3b334a;
      font-weight: 400;
      line-height: 1.5;
      font-size: .75rem;
      margin-top: .5rem;
      position: relative;
      border-radius: 5px;
      box-sizing: border-box;
      padding: .375rem 1.2rem;
      background-color: $white;
      border: 0 solid #ced4da;
      box-shadow: 0 0 0 1px #e0e0e0, 0 2px 4px 0 rgba($black, .07), 0 1px 1.5px 0 rgba($black, .05) !important;

      &--multiselect {
        padding: 0px;
        min-height: 52px;
        height: max-content;

        .multiselect__tags {
          overflow: auto;
          min-height: 52px !important;
          box-sizing: border-box !important;
          padding: .375rem 1.2rem !important;
        }
      }

      &:focus {
        background-color: $white !important;
      }

      &-error {
        margin-top: 2px;
        font-size: 9px;
        color: #dc3545;
      }

      &-warning {
        font-size: 10px;
      }
    }

    &__button {
      margin-top: 18px;
    }

    &__bg {
      top: 0;
      left: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
      position: fixed;
      background-color: rgba(black, .5);
    }
  }
</style>
